import { render, staticRenderFns } from "./forexTabs.vue?vue&type=template&id=d86336ac&scoped=true"
import script from "./forexTabs.vue?vue&type=script&lang=js"
export * from "./forexTabs.vue?vue&type=script&lang=js"
import style0 from "./forexTabs.vue?vue&type=style&index=0&id=d86336ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86336ac",
  null
  
)

export default component.exports